import { COMPANY, FUND, INDEX, INDICATOR, SECURITYLIST_GROUP_MULTI } from 'Angular/constants/core.constants';
import { ADD, EXCLUDE, INTERSECT } from 'SecurityListsApp/ts/constants';
export const DEFAULT_SECURITY_LIST_MODAL_HEADER_TEXT = 'Select a Security List';
export const DEFAULT_SECURITY_GROUP_TAB_OPTIONS = [
    SECURITYLIST_GROUP_MULTI,
    COMPANY,
    FUND,
    INDICATOR,
    INDEX,
];
export const SECURITY_GROUP_TAB_LABEL_MAP = [
    { groupName: SECURITYLIST_GROUP_MULTI, tabName: 'My Lists' },
    { groupName: COMPANY, tabName: 'Equities' },
    { groupName: FUND, tabName: 'Funds' },
    { groupName: INDICATOR, tabName: 'Indicators' },
    { groupName: INDEX, tabName: 'Indices' },
];
export const SET_OPERATION_TO_RADIO_BUTTON_MAP = {
    [INTERSECT]: {
        label: 'Intersect',
        value: INTERSECT,
    },
    [EXCLUDE]: {
        label: 'Exclude',
        value: EXCLUDE,
    },
    [ADD]: {
        label: 'Add',
        value: ADD,
    },
};
export const SET_OPERATION_RADIO_BUTTONS = Object.values(SET_OPERATION_TO_RADIO_BUTTON_MAP);
